/**
 * @description: 客遗记录报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="or-kj-report">
        <div class="kj-list">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="kjTime">
                        <input type="text" class="form-control laydate-icon" v-model="kjStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="kjEndTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="kjShop" data-placeholder="请选择门店"></select>
                </div>
                <label class="list-label-3">包厢号:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="kj_box" data-placeholder="请选择包厢号" disabled>
                    </select>
                </div>
                <label class="list-label-2">状态:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="kj_status">
                        <option value="0">全部</option>
                        <option value="1">已取物品</option>
                        <option value="-1">未取物品</option>
                    </select>
                </div>
            </div>
            <div class="row row-margin">
                <div class="col-md-1 ct-col kj-tit-sel">
                    <select class="form-control" ref="kjperf_tit_sel">
                        <option value="name">拾到员工姓名</option>
                        <option value="number">拾到员工工号</option>
                    </select>
                </div>
                <div class="col-md-2 jh-con-val">
                    <input type="text" class="form-control" v-model="kjperf_con_val" :placeholder="kjperf_con_phd">
                </div>
                <label class="list-label-4">客遗类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="kj_type">
                        <option value="0">全部</option>
                        <option value="1">客遗酒水</option>
                        <option value="2">私人物品</option>
                    </select>
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitKjTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getKjExportSet">导出</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="kjList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="kjExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='kjExport_allcheck' @click='kjExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='kjExport_checkModel' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='kjExport_checkModel' value="id">
                            <label>客遗单号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='kjExport_checkModel' value="pickup_time">
                            <label>客遗时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='kjExport_checkModel' value="room_name">
                            <label>包厢号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='kjExport_checkModel' value="pickup_user_name">
                            <label>拾到员工</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='kjExport_checkModel' value="type">
                            <label>客遗类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='kjExport_checkModel' value="status">
                            <label>状态</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='kjExport_checkModel' value="goods_name">
                            <label>客遗物品</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='kjExport_checkModel' value="quantity">
                            <label>数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='kjExport_checkModel' value="goods_unit_name">
                            <label>单位</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='kjExport_checkModel' value="pickup_remark">
                            <label>客遗备注</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='kjExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='kjExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                kjStartTime: "",
                kjEndTime: "",
                kjperf_con_val: "",
                kjperf_con_phd: "请输入拾到员工姓名",
                kjperf_field: "name",
                kjExport_allcheck: false,
                c_kjExport_allcheck: false,
                kjExport_checkModel: [],
                kjExport_checkData: ['shop_name', 'id', 'pickup_time', 'room_name', 'pickup_user_name', 'type', 'status', 'goods_name', 'quantity', 'goods_unit_name', 'pickup_remark'],
                kjExport_type: 1,
            }
        },
        watch: {
            kjExport_checkModel: {
                handler: function (val, oldVal) {
                    if(this.kjExport_checkModel.length >= this.kjExport_checkData.length) {
                        this.kjExport_allcheck = true;
                        this.c_kjExport_allcheck = true;
                    } else {
                        this.kjExport_allcheck = false;
                        this.c_kjExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            const _this = this
            // 日期
            _this.kjStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.kjEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.innitDate(); // 日期
            _this.shopDatas = [];
            _this.innitInput();  // 门店
            // 下拉选项
            $(_this.$refs.kjperf_tit_sel).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1,
                width: '100%'
            }).change(function() {
                _this.kjperf_field = $(this).val();
                if(_this.kjperf_field == 'name') {
                    _this.kjperf_con_phd = '请输入拾到员工姓名';
                } else if(_this.kjperf_field == 'number') {
                    _this.kjperf_con_phd = '请输入拾到员工工号';
                }
            });
            // 类型
            $(_this.$refs.kj_type).select2({
                width: '100%',
                minimumResultsForSearch: -1,
                language: "zh-CN",
            });
            // 状态
            $(_this.$refs.kj_status).select2({
                width: '100%',
                minimumResultsForSearch: -1,
                language: "zh-CN",
            });
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.kjStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.kjEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.kjStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.kjEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.kjTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit : {
                        days : 31
                    },
                }, function(start, end, label) {
                    _this.kjStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.kjEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.kjShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                if(e.params.data.text == "全部") {
                                    $(_this.$refs.kj_box).html("");
                                    $(_this.$refs.kj_box).prop("disabled", true);
                                    return;
                                }
                                $(_this.$refs.kj_box).prop("disabled", false);
                                _this.getRoomdata(e.params.data.id);
                                _this.setShopDefaultTime(e.params.data.id);
                            });
                            $(_this.$refs.kjShop).val(data.response.result[1].id).trigger('change');
                            $(_this.$refs.kj_box).prop("disabled", false);
                            _this.getRoomdata(data.response.result[1].id);
                            _this.setShopDefaultTime(data.response.result[1].id);
                            _this.innitKjTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取包厢数据
            getRoomdata: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getAllRoom",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let roomDatas = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                roomDatas.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.kj_box).html("");
                            $(_this.$refs.kj_box).select2({
                                data: roomDatas,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },



            // 客遗记录报表表格
            innitKjTable: function() {
                let _this = this;
                $(_this.$refs.kjList).bootstrapTable('destroy');
                $(_this.$refs.kjList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 15,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getKjList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "130",
                        formatter: function(value, row, index) {
                            return value.length > '14' ? value.slice(0, 14) + '...' : value
                        }
                    }, {
                        field: "id",
                        title: "客遗单号",
                        width: "110"
                    }, {
                        field: "pickup_time",
                        title: "客遗时间",
                        width: "100"
                    }, {
                        field: "room_name",
                        title: "包厢号",
                        width: "8%"
                    }, {
                        field: "pickup_user_name",
                        title: "拾到员工",
                        width: "8%"
                    }, {
                        field: "type",
                        title: "客遗类型",
                        width: "8%"
                    }, {
                        field: "pickup_remark",
                        title: "客遗备注",
                        width: "8%"
                    }, {
                        field: "status",
                        title: "状态",
                        width: "8%"
                    }, {
                        field: "goods_name",
                        title: "客遗物品",
                        width: "10%"
                    }],
                });
            },
            // 获取客遗记录报表
            getKjList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_date": _this.kjStartTime,
                            "end_date": _this.kjEndTime,
                            "shop_id": $(_this.$refs.kjShop).val(),
                            "room_id": $.trim($(_this.$refs.kj_box).val()),
                            "key_word": _this.kjperf_field,
                            "search_word": _this.kjperf_con_val,
                            "type": $(_this.$refs.kj_type).val(),
                            "status": $(_this.$refs.kj_status).val()
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/guestLeaveRecordList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getKjExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport/guestLeaveRecordListExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.kjExport_checkModel = data.response.result.export_fields;
                                _this.kjExport_type = data.response.result.export_type;
                            } else {
                                _this.kjExport_checkModel = _this.kjExport_checkData;
                                _this.kjExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.kjExport_alert)
                }, function() {
                    _this.exportKjList();
                });
            },
            // 导出字段全选
            kjExportCheckedAll: function() {
                let _this = this;
                _this.kjExport_allcheck = _this.c_kjExport_allcheck;
                if(!_this.kjExport_allcheck) { // 实现全选
                    _this.kjExport_checkModel = [];
                    _this.kjExport_checkData.forEach(function(item) {
                        _this.kjExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.kjExport_checkModel = [];
                }
            },
            // 导出客遗记录报表
            exportKjList: function() {
                let _this = this,
                    shop_id = $(_this.$refs.kjShop).val();
                let export_fields = JSON.stringify(_this.kjExport_checkModel);
                window.location.href = Vue.ctUrl + "FinanceReport/guestLeaveRecordListExport?" +
                    "&start_date=" + _this.kjStartTime +
                    "&end_date=" + _this.kjEndTime +
                    "&shop_id=" + shop_id +
                    "&room_id=" + $.trim($(_this.$refs.kj_box).val()) +
                    "&key_word=" + _this.kjperf_field +
                    "&search_word=" + _this.kjperf_con_val +
                    "&type=" + $(_this.$refs.kj_type).val() +
                    "&status=" + $(_this.$refs.kj_status).val() +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.kjExport_type;
                //debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    .kj-list {
        .kj-tit-sel {
            width: 125px;
            padding: 0;
        }
        table {
            // table-layout: fixed;
            word-break: break-all;
        }
    }
</style>